var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"y-center",staticStyle:{"background":"none","padding":"16px 0"}},[(_vm.title)?_c('div',{staticClass:"size-md bolder",staticStyle:{"margin-right":"10px"}},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9158ca4e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/zzcbpmDashboard/common/m-header.vue
// module id = null
// module chunks = 